
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 13 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M5.998 5.236a5.792 5.792 0 015.037-2.874 5.792 5.792 0 01-.978 5.716l-2 2.402-.485.414-3.37-2.36.223-.598 1.573-2.7zm-2.77 1.962l1.555-2.67.037-.062c-.776.32-1.763.97-2.818 2.27l1.226.462zM6.24 2.755A7.202 7.202 0 0111.521.978a.77.77 0 01.648.454 7.202 7.202 0 01.136 5.57c.113.31.222.727.267 1.241.1 1.186-.147 2.837-1.384 4.879-.503.828-1.631.845-2.219.16l-.741-.864a.837.837 0 01-.943-.014l.102.071-.402.574a1.404 1.404 0 01-1.956.341l-2.303-1.613a1.404 1.404 0 01-.349-1.954l.402-.574.101.07a.837.837 0 01-.334-.88L1.48 8.038C.635 7.72.265 6.654.871 5.898 2.367 4.038 3.833 3.24 4.982 2.93a4.84 4.84 0 011.258-.174zm3.773 9.591c.862-1.437 1.134-2.585 1.17-3.424a7.37 7.37 0 01-.045.055L9.16 11.352l.853.994zm-3.778-.678L3.93 10.056l-.402.573 2.304 1.613.402-.574z","clip-rule":"evenodd"}})])
          )
        }
      }
    